import React, { useState, useRef } from "react";
import { Box, TextField, IconButton } from "@mui/material";
import {
    AttachFile as AttachFileIcon,
    MicNone as MicNoneIcon,
    KeyboardAltOutlined as KeyboardAltOutlinedIcon,
} from "@mui/icons-material";
import { COLORS } from "../../assets/colors";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CircularButton from "../../sharedComponents/CircularButton"

const SearchBar = ({ onSendMessage, isLoading, placeholder = "Demande à ConverseQuery...", handleStopTask }) => {
    const [inputValue, setInputValue] = useState("");
    const fileInputRef = useRef(null);

    // Gérer le clic sur l'icône "Ajouter un fichier"
    const handleFileClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Gérer la sélection du fichier
    const handleFileChange = (event) => {
        const files = event.target.files;
        if (files.length > 0) {
            console.log("Fichier sélectionné:", files[0].name);
            // Gérer l'envoi du fichier si nécessaire
        }
    };

    // Gérer l'envoi du message
    const handleSendMessage = () => {
        if (inputValue.trim()) {
            onSendMessage(inputValue); // Envoyer la valeur au parent
            setInputValue(""); // Réinitialiser la valeur de l'input
            return inputValue; // Retourner la valeur
        }
        return null; // Retourner null si l'input est vide
    };

    // Gérer l'appui sur la touche "Enter"
    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            handleSendMessage();
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: "50px",
                bgcolor: COLORS.WHITE_BLUE,
                backdropFilter: "blur(10px)",
                padding: "5px",
                width: { xs: '90%', sm: '70%' },
                mx: { xs: '5%', sm: '15%' },
                // mt: '3%',
            }}        >
            {/* Icône de fichier */}
            {/* <Box
                sx={{
                    borderRadius: "50%",
                    bgcolor: COLORS.GRAY_AVATAR,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "8px",
                }}
            >
                <IconButton sx={{ color: COLORS.BLACK_TEXT, fontSize: 24 }} onClick={handleFileClick}>
                    <AttachFileIcon sx={{ fontSize: 20 }} />
                </IconButton>
            </Box> */}

            {/* Champ de texte pour la saisie */}
            <TextField
                fullWidth
                placeholder={placeholder}
                variant="outlined"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyPress}
                // slotProps={{
                sx={{
                    border: "none",
                    backgroundColor: "transparent",
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    cursor: isLoading ? 'text' : 'text',
                }}
                // }}
                disabled={isLoading}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {
                    isLoading == true ?
                        <CircularButton onClickStop={handleStopTask} />
                        :
                        <Box
                            sx={{
                                borderRadius: "50%",
                                bgcolor: inputValue == "" ? COLORS.WHITE_BLUE : COLORS.PINK_INTELCIA,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <IconButton
                                sx={{
                                    color: inputValue == "" ? COLORS.GRA_ARROW : COLORS.WHITE,
                                    "&:hover": { backgroundColor: "action.hover" }
                                }}
                                onClick={handleSendMessage}
                            >
                                <ArrowUpwardIcon />
                            </IconButton>
                        </Box>
                }

                {/* <Box
                    sx={{
                        borderRadius: "50%",
                        bgcolor: COLORS.GRAY_AVATAR,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <IconButton
                        sx={{ color: COLORS.BLACK_TEXT, "&:hover": { backgroundColor: "action.hover" } }}
                    >
                        <MicNoneIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                </Box> */}

                {/* <Box
                    sx={{
                        borderRadius: "50%",
                        bgcolor: COLORS.GRAY_AVATAR,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "8px",
                    }}
                >
                    <IconButton
                        sx={{ color: COLORS.BLACK_TEXT, "&:hover": { backgroundColor: "action.hover" } }}
                        onClick={handleFileClick}
                    >
                        <KeyboardAltOutlinedIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                </Box> */}
            </Box>

            <input
                ref={fileInputRef}
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="application/pdf, image/*, .doc, .docx"
            />
        </Box>
    );
};

export default SearchBar;
